import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import StatBar from "@/components/landing/StatBar";
import EducationPromise from "@/components/landing/EducationPromise";
import Features from "@/components/landing/Features";
import OhioCompliance from "@/components/landing/OhioCompliance";
import ComplianceQuiz from "@/components/landing/ComplianceQuiz";
import ProductShowcase from "@/components/landing/ProductShowcase";
import HowItWorks from "@/components/landing/HowItWorks";
import Testimonials from "@/components/landing/Testimonials";
import Pricing from "@/components/landing/Pricing";
import FAQ from "@/components/landing/FAQ";
import DemoRequest from "@/components/landing/DemoRequest";
import Footer from "@/components/landing/Footer";

export default function LandingPage() {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-stone-50 text-stone-900">
      <Nav />
      <main>
        <Hero />
        <StatBar />
        <EducationPromise />
        <Features />
        <OhioCompliance />
        <ComplianceQuiz />
        <ProductShowcase />
        <HowItWorks />
        <Testimonials />
        <Pricing />
        <FAQ />
        <DemoRequest />
      </main>
      <Footer />
    </div>
  );
}
